import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { CustomersService } from '../services/customers.service';
import { MatTableGeneratorComponent } from '../../shared/mat-table-generator/mat-table-generator.component';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { Customer } from '../../dto/customer';
import {
  formatPhoneNumeric,
  parseDateToServerDateOffset,
  toDateString,
  toDateTimeString
} from '../../providers/app-date-adapter';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private customersService: CustomersService,

  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  dataSource = new MultiCrudDataSource(this.customersService);
  columns = [

    { columnDef: 'title', header: 'Title', cell: (row: Customer) => `${row.title}` },
    { columnDef: 'firstName', header: 'First name', cell: (row: Customer) => `${row.firstName}` },
    { columnDef: 'lastName', header: 'Last name', cell: (row: Customer) => `${row.lastName}` },
    { columnDef: 'address', header: 'Address', cell: (row: Customer) => `${row.address}` },
    { columnDef: 'city', header: 'City', cell: (row: Customer) => `${row.city}` },
    { columnDef: 'zipCode', header: 'Zip code', cell: (row: Customer) => `${row.zipCode}` },
    { columnDef: 'email', header: 'Email', cell: (row: Customer) => `${row.email}` },
    { columnDef: 'phone', header: 'Mobile', cell: (row: Customer) => `${formatPhoneNumeric(row.phone)}` },
    { columnDef: 'dob', header: 'Date of birth', cell: (row: Customer) => `${toDateString(row.dob)}` },
    { columnDef: 'partnerCustomerId', header: 'Partner-ID', cell: (row: Customer) => this.getPartnerId(row) },
    // { columnDef: "countryName", header: "Country", cell: (row: Customer) => `${row.countryName}` },

    { columnDef: 'cardsCount', header: 'Cards', cell: ( row: Customer ) => `${ row.cards.length }` },


  ];

  getPartnerId(row: Customer) {
    let r = '';
    let c = 0;
    const array = row.orders.filter(x => x.partnerCustomerId != null);
    const resArr = [];

    if (array.length > 0) {
      row.orders.forEach((item) => {
        const i = resArr.findIndex(x => x.partnerCustomerId == item.partnerCustomerId);
        if (i <= -1) {
          if (c > 0) {
            r = r + ', ';
          }
          resArr.push({id: item.id, name: item.partnerCustomerId});
          r = item.partnerCustomerId;
          c++;
        }

      });
    }

    return r == '' ? '-' : r;
  }

  getViewLink = (item: Customer): string => item.id.toString();

  getEditLink = (item: Customer): string => item.id.toString() + '/edit';

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

}
